const GOOGLE_PLAY_URL = process.env.REACT_APP_GOOGLE_PLAY_URL
  || "https://play.google.com/store/apps/details?id=se.lapstr.app";

export default function GooglePlayDownloadLink() {
  return (
    <a
      className="native-google-play-link"
      href={GOOGLE_PLAY_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Ladda ned Lapstr på Google Play"
    >
      <img src="/badges/google-play-sv.png" alt="Ladda ned på Google Play" />
    </a>
  );
}
